import React from 'react';
import type { ReactElement, ChangeEvent } from 'react';
import { TextArea, spacingHelper } from '@construct-kit/core';
import styled from 'styled-components';
import { FilterWrapper } from './FilterWrapper';

type KeywordsFilterProps = {
  value: string;
  onChange: (newValue: string) => void;
};

const StyledTextArea = styled(TextArea)`
  margin-top: ${spacingHelper('medium')};
`;

export const KeywordsFilter = ({ value, onChange }: KeywordsFilterProps): ReactElement => {
  const handleKeywordsInputChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    onChange(event.target.value);
  };

  return (
    <FilterWrapper title="Keywords" showDivider={false}>
      <StyledTextArea
        label="keywords"
        hideLabel
        name="KeywordsFilter"
        placeholder="Input text"
        value={value}
        onChange={handleKeywordsInputChange}
      />
    </FilterWrapper>
  );
};
